import { NgModule } from '@angular/core';

import { RedirectService } from './services/redirect.service';

@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [RedirectService],
})
export class RedirectServiceModule {}
